angular.module('smartorg.r6.navs.menu', [
    require('../../../../../../components/share-link/app/js/plumbing/app'),
]);
require('./menu-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.navs.menu';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/menu/app/js/plumbing/app.js